// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnPink_my_btn__+paqI"};